import C from "@/store/constants";

const AN_SERVICE_NAME = C.service.ANNOTATION_SERVICE;

export default {
  namespaced: true,

  actions: {
    // Annotations
    //
    getAnnotations({ commit, dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .get(`/annotations/media/${encodeURIComponent(id)}`)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    getAnnotationsByReference({ commit, dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .get(`/annotations/ref/${encodeURIComponent(id)}`)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    getAnnotation({ commit, dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .get(`/annotations/${encodeURIComponent(id)}`)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    addAnnotation({ commit, dispatch }, annotation) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .post("/annotations", annotation)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    updateAnnotation({ commit, dispatch }, { id, annotation }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .put(`/annotations/${encodeURIComponent(id)}`, annotation)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    deleteAnnotation({ commit, dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .delete(`/annotations/${encodeURIComponent(id)}`)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    importAnnotations({ dispatch }, { id, layer, types, state }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true })
          .then((api) =>
            api.post(`/import/${id}?layer=${layer}&state=${state || ''}`, types)
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    exportPDF({ dispatch }, { id, layers }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true })
          .then((api) =>
            api.post(`/export/${id}`, layers, { responseType: "blob" })
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },

    // Layers
    //
    getLayers({ commit, dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .get(`/layers/media/${encodeURIComponent(id)}`)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    addLayer({ commit, dispatch }, layer) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .post("/layers", layer)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    updateLayer({ commit, dispatch }, { id, layer }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .put(`/layers/${encodeURIComponent(id)}`, layer)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
    deleteLayer({ commit, dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AN_SERVICE_NAME, { root: true }).then((api) => {
          api
            .delete(`/layers/${encodeURIComponent(id)}`)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
        });
      });
    },
  },
};
